import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { makeMultiplexedTransport } from '@sentry/core';

import App from './App';

const EXTRA_KEY = 'ROUTE_TO';
const transport = makeMultiplexedTransport(
  Sentry.makeFetchTransport,
  (args) => {
    const event = args.getEvent();
    if (
      event &&
      event.extra &&
      EXTRA_KEY in event.extra &&
      Array.isArray(event.extra[EXTRA_KEY])
    ) {
      return event.extra[EXTRA_KEY];
    }
    return [];
  }
);

Sentry.init({
  dsn: process.env.REACT_APP_MFE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({}),
    Sentry.replayIntegration(),
    Sentry.moduleMetadataIntegration(),
  ],
  transport,
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE),
  replaysSessionSampleRate: Number(
    process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE
  ),
  replaysOnErrorSampleRate: Number(
    process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
  ),
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT_NAME ?? 'staging',

  // The following code is to prevent logging errors to sentry from development environment
  beforeSend: (event) => {
    if (event?.exception?.values?.[0].stacktrace?.frames) {
      const { frames } = event.exception.values[0].stacktrace;

      const routeTo = frames
        .filter((frame) => frame.module_metadata && frame.module_metadata.dsn)
        .map((v) => v.module_metadata)
        .slice(-1);

      if (routeTo.length) {
        event.extra = {
          ...event.extra,
          [EXTRA_KEY]: routeTo,
        };
      }
    }

    return process.env.REACT_APP_SENTRY_ENVIRONMENT_NAME ? event : null;
  },
});

const el = document.querySelector('#one-bizongo-container');
if (el) {
  const root = ReactDOM.createRoot(el);
  root.render(<App />);
}

// if (process.env.NODE_ENV === 'development') {
//   const { worker } = await import('./mocks/browser');
//   worker.start();
// }

export default App;
